import { Component, Input, TemplateRef } from '@angular/core';

export class DetailsTableRow {
  key?: any;
  value?: any;
  valueType?:
    | undefined
    | 'email'
    | 'phone'
    | 'internal_route'
    | 'external_route'
    | 'boolean'
    | 'date_time'
    | 'date_time_with_seconds'
    | 'date'
    | 'edit'
    | 'currency' = undefined;
  template?: TemplateRef<any>;
  route?: string;
}

@Component({
  selector: 'tcc-mono-details-table',
  templateUrl: './details-table.component.html',
  styleUrls: ['./details-table.component.scss']
})
export class DetailsTableComponent {
  @Input() public rows: DetailsTableRow[] = [];
  @Input() public gridPadding: number = 12;
  @Input() public gridColumnPadding: number = 12;
  @Input() public noValuePlaceholder: string = '';
  @Input() public firstColumnSize: number = 6;

}
